module.exports = __webpack_public_path__ + "img/prod-kitchen.3318bd2a.jpg";